import type { HideGeofences, ShowGeofences, ToggleShowGeofences } from './actions';
import { ActionTypes } from './actionTypes';

export const showGeofences = (): ShowGeofences => ({
  type: ActionTypes.SHOW_GEOFENCES,
});

export const hideGeofences = (): HideGeofences => ({
  type: ActionTypes.HIDE_GEOFENCES,
});

export const toggleShowGeofences = (): ToggleShowGeofences => ({
  type: ActionTypes.TOGGLE_SHOW_GEOFENCES,
});
